import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import AddFavourite from "../../utility/js/addFav";
import documentService from "./document-upload-service";
import EncryptUtility from "../../utility/js/encrypt-utility";
import Utility from "../../../shared/utility.js";
export default {
  data: () => ({
    name: "DocumentMastersAccountDetails",
    userId: EncryptUtility.localStorageDecrypt("userID"),
    route: "",
    mainPage: "",
    subPage: "",
    subPageUrl: "",
    appPageName: "",
    pageName: "",
    backSlash: true,
    backSlashParent: true,
    refresh: true,
    totalRecords: 0,
    accountMastersDetails: [],
    searchFilter: "",
    selectedDocumentType: 0,
    documentTypeList: [],
    selectedTrainingCompleted: "",
    trainingCompletedList: ["YES", "NO"],
    // selectedPersonnel: 0,
    // personnelList: [],
    documentEndUserListData: [],
    end_date: "",
    uploadedFileDialog: false,
    uploadedFileDialogWidth: "1100",
    base64String: "",
    pageCount: 0,
    page: 1,
    documentEndUserListHeaders: [
      { text: "Document No", value: "document_number", class: "primary customwhite--text" },
      { text: "Title", value: "title", class: "primary customwhite--text" },
      { text: "Document Type", value: "type_name", class: "primary customwhite--text" },
      // { text: "Status", value: "status_name", class: "primary customwhite--text" },
      { text: "Account Name", value: "account_name", class: "primary customwhite--text" },
      // { text: "Applicable Personnel", value: "applicable_personnel", class: "primary customwhite--text" },
      { text: "Training Required", value: "is_training_required", class: "primary customwhite--text" },
      { text: "Training Status", value: "training_completed", class: "primary customwhite--text" },
      { text: "Completed On", value: "end_date", class: "primary customwhite--text" },
      { text: "File Name", value: "original_file_name", class: "primary customwhite--text" },
      { text: "View Document", value: "actions", class: "primary customwhite--text" },
    ],
  }),
  computed: {
    frameSrc() {
      return this.base64String;
    },
  },
  async created() {
    let dataSimple = await AddFavourite.getPageAction(this.userId, "app-service-level");
    this.route = this.$route.path.replace("/", "").split("/")[0];
    let data = await AddFavourite.getParentPageAction(this.userId, this.route);
    this.actionList = dataSimple.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.subPageUrl = data.subPageUrl;
    this.appPageName = data.appPageName;
    this.loadDropdowns();
    this.getDocumentData(1);
  },
  methods: {
    //Reset function
    resetFunction() {
      this.totalRecords = 0;
      this.searchFilter = "";
      this.selectedDocumentType = 0;
      this.selectedTrainingCompleted = "";
      this.documentTypeList = [];
      // this.selectedPersonnel = 0;
      // this.personnelList = [];
      this.documentEndUserListData = [];
      this.uploadedFileDialog = false;
      this.uploadedFileDialogWidth = "1100";
      this.base64String = "";
      this.pageCount = 0;
      this.page = 1;
      this.loadDropdowns();
      this.getDocumentData(1);
    },
    async loadDropdowns() {
      let masterObj = {
        pass: 0,
        user_id: parseInt(this.userId),
      };
      let masterData = await documentService.documentLoadMasters("post", masterObj, false);
      if (masterData.message !== "NA") {
        this.documentTypeList = masterData.document_type;
        // this.personnelList = masterData.applicable_personnel;
      }
    },
    //Get data table data
    async getDocumentData(page) {
      let obj = {
        page_number: page,
        page_size: 20,
        search_string: this.searchFilter,
        user_id: parseInt(this.userId),
        type_key: parseInt(this.selectedDocumentType),
        training_completed: this.selectedTrainingCompleted,
      };
      let data = await documentService.documentEndUserList("post", obj, false);
      if (data.message !== "NA" && data.length !== 0) {
        this.totalRecords = data[0].total_records;
        this.pageCount = data[0].total_pages;
        const newArr = data.map((obj) => {
          return {
            ...obj,
            end_date: obj.end_date !== null && obj.end_date !== undefined ? Utility.displayDateFormat(obj.end_date) : "",
            // applicable_personnel: JSON.parse(obj.applicable_personnel),
          };
        });
        this.documentEndUserListData = newArr;
      } else {
        this.totalRecords = 0;
        this.pageCount = 0;
        this.documentEndUserListData = [];
      }
    },
    //Get Search data
    getSearchData() {
      if (this.searchFilter.length > 3) {
        this.getDocumentData(1);
      }
    },
    // Clear all filters and refresh table
    clearFilters() {
      this.searchFilter = "";
      this.selectedDocumentType = 0;
      this.selectedTrainingCompleted = "";
      // this.selectedPersonnel = 0;
      this.getDocumentData(1);
    },
    toggleUploadedDialogWidth() {
      this.uploadedFileDialogWidth = this.uploadedFileDialogWidth === "100%" ? "1100" : "100%";
    },
    async downloadFile(item) {
      let data = await documentService.getDocumentSasFileUrl("get", item.system_file_name);
      if (data !== "") {
        this.base64String = data;
        this.uploadedFileDialog = true;
      }
    },
    //View Document
    viewDocument(item) {
      this.$router.push({
        name: "myDocumentDetails",
        params: {
          documentID: btoa(item.document_id.toString()),
        },
      });
    },
  },
  components: {
    breadcrumbComp,
  },
};
